import axios from 'apis';
import { sessionService } from 'redux-react-session';
import { getThunkActionCreator } from 'redux-thunk-routine';
import {
  getPublicStorageFacilityInspectionRoutine,
  submitPublicStorageFacilityInspectionRoutine,
  createStorageFacilityInspectionReportRoutine,
} from 'actions';

const reportSummaryAttributes = [
  'id',
  'status',
  'completed_by_name',
  'completed_by_date',
  'expires_on',
  'public_url',
  'created_at',
];

export const getPublicStorageFacilityInspection = getThunkActionCreator(
  getPublicStorageFacilityInspectionRoutine,
  async (id) => axios.get(`/public/storage_facility_inspection_reports/${id}`)
);

export const submitPublicStorageFacilityInspection = getThunkActionCreator(
  submitPublicStorageFacilityInspectionRoutine,
  async ({ id, storage_facility_inspection_report }) =>
    axios.patch(`/public/storage_facility_inspection_reports/${id}`, { storage_facility_inspection_report })
);

export const createStorageFacilityInspectionReport = getThunkActionCreator(
  createStorageFacilityInspectionReportRoutine,
  async (locationId) => {
    const { token: access_token } = await sessionService.loadSession();

    return axios.post(`/user/locations/${locationId}/inspection_reports`, {
      access_token,
      attributes: reportSummaryAttributes,
    });
  }
);

export { reportSummaryAttributes };
